export const customMenuLinkRouteNames = {
  default: 'location-custom-menu-link-v2',
}
